import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
//import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
export class FavoriteDialog {
  private 
}
@Component({
  selector: 'app-custom-comment-popup',
  templateUrl: './custom-comment-popup.component.html',
  styleUrls: ['./custom-comment-popup.component.scss']
})

export class CustomCommentPopupComponent implements OnInit {
  comment = ""
  componentId=0
  constructor(public dialogRef: MatDialogRef<CustomCommentPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.comment = this.data.comment
    this.componentId = this.data.componentId
  }
  onNoClick(): void {
    this.dialogRef.close(false);
}



updateComment() {
   
    // const result = new favPopUpModel();
    // result.operation = this.operation;
    // result.SearchFavorite = this.model;
    let obj = {
      comment:this.comment,
      componentId:this.componentId
    }
     this.dialogRef.close(obj);
    
}

closeModal(){
  this.dialogRef.close();

}

}
